// @flow

import {createStore, compose, applyMiddleware} from "redux"
import thunk from "redux-thunk"
import {createLogger} from "redux-logger"

import rootReducer from "../reducers"

export default (initialState: Object = {}): Object => {
  const middlewares = [thunk]
  if (process.env.NODE_ENV !== "production") {
    middlewares.push(
      createLogger({
        collapsed: true,
      })
    )
  }
  const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(...middlewares),
      window.devToolsExtension ? window.devToolsExtension() : (f) => f
    )
  )
  /* if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers/index')
      store.replaceReducer(nextRootReducer)
    })
  } */

  return store
}
